import Vue from "vue";
import "@/assets/js/quasar";
import store from "@/store";
import Vuelidate from "vuelidate";

import Trend from "vuetrend";
import OneAtATime from "@/plugins/OneAtATime";
import BackendWebsocketEvents from "@/plugins/BackendWebsocketEvents";
import BackendDrivenEvents from "@/plugins/BackendDrivenEvents";
import NotifyToast from "@/plugins/NotifyToast";
import { readCookie, isValidBrowser, isValidPlatform } from "@/assets/js/appFunc";
import DeniedApp from "@/pages/denied/app.vue";
import i18n from "../../i18n";
import App from "./app.vue";
import router from "./router";
import GlobalUtils from "../../components/UserInterfaces/plugins/globalUtils";

Vue.use(Vuelidate);
Vue.use(Trend);
Vue.use(OneAtATime);
Vue.use(BackendDrivenEvents);
Vue.use(BackendWebsocketEvents);
Vue.use(NotifyToast);
Vue.use(GlobalUtils);

Vue.config.productionTip = false;

const browserValid = isValidPlatform() && isValidBrowser();

new Vue({
    router: browserValid ? router : undefined,
    i18n,
    store,
    created() {
        if (browserValid) {
            if (readCookie("jwt1")) {
                this.$store.dispatch("userProfile/saveCookieInfo");
            }

            this.$toast.init(this);
            this.$oneAtATime.init(this);
            this.$backendDrivenEvents.init(this);
            this.$backendWebsocketEvents.init(this);
            const wrongTenant = JSON.parse(localStorage.getItem("wrongTenantActive"));
            if (!wrongTenant) {
                store().dispatch("main/actMaintenanceSchedule").then(rsp => {
                    if (rsp.data.status === "SCHEDULED") {
                        localStorage.setItem("maintenanceSchedule", true);
                        localStorage.setItem("maintenanceMessage", rsp.data.message);
                    } else {
                        localStorage.removeItem("maintenanceSchedule");
                        localStorage.removeItem("maintenanceMessage");
                    }
                });
                store().dispatch("main/actMaintenanceActive").then(rsp => {
                    if (rsp.data.inProgress) {
                        localStorage.setItem("maintenanceStarted", rsp.data.inProgress);
                        localStorage.removeItem("maintenanceMessage");
                        localStorage.removeItem("maintenanceSchedule");
                        const maintenanceUser = localStorage.getItem("maintenanceUser");
                        if (rsp.data.redirectUrl && !maintenanceUser && !window.location.href.includes("maintenance")) {
                            window.location.href = rsp.data.redirectUrl;
                        }
                    } else {
                        localStorage.removeItem("maintenanceStarted");
                        localStorage.removeItem("maintenanceUser");
                    }
                });
            }
        }
    },
    render: h => h(browserValid ? App : DeniedApp)
}).$mount("#app");
